'use client';
import { ReactNode } from "react";

interface LandingPageLayoutProps {
      children: ReactNode;
}

const LandingPageLayout = ({ children }: LandingPageLayoutProps) => {
      return <div className="w-full">
            {children}
      </div>
};

export default LandingPageLayout;


